import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart3, TrendingUp, PieChart, Activity } from "lucide-react";
export default function AdvancedToolsWeTeach() {
  const tools = [{
    id: 1,
    name: "TC2000\nTradingView",
    description: "Plataforma avanzada de análisis técnico con gráficos interactivos y herramientas de dibujo profesionales.",
    icon: BarChart3
  }, {
    id: 2,
    name: "Plataformas de Trading",
    description: "Enseñamos plataformas financieras de trading en tiempo real, y herramientas analíticas institucionales.",
    icon: TrendingUp
  }, {
    id: 3,
    name: "Terminal de Noticias En Tiempo Real",
    description: "Información en tiempo real de noticias del mercado para análisis de trading, y estrategias de operaciones.",
    icon: Activity
  }, {
    id: 4,
    name: "Portafolio Financiero",
    description: "Educación en construcción de portafolios de inversión para seguimiento a largo plazo.",
    icon: PieChart
  }];
  return <section className="relative bg-background py-16 lg:py-24">
      <div className="container mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-12 text-center animate-fade-in-up">
          <h2 className="text-3xl lg:text-4xl font-semibold text-foreground tracking-wide mb-4">
            Herramientas Avanzadas que Enseñamos
          </h2>
          <p className="text-base text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Domina el software y las herramientas analíticas que utilizan los profesionales en Wall Street
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {tools.map((tool, i) => {
          const IconComponent = tool.icon;
          return <Card key={tool.id} data-index={i} className="card hover-lift border border-border shadow-soft bg-surface">
                <CardHeader>
                  <div className="flex items-center justify-center w-12 h-12 rounded-md bg-primary/10 mb-4">
                    <IconComponent className="w-6 h-6 text-primary" />
                  </div>
                  <CardTitle className="text-xl font-semibold text-foreground">
                    {tool.name}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {tool.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}